<div class="item-block" *ngIf="!viewed && roadBlock">
  <div class="container-fluid bg-light">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <a class="navbar-brand" [routerLink]="['']"><img src="assets\logo.png"></a>
        </nav>
      </div>
    </div>
  <div class="item-block-container">
      <div class="item-holder">
          <a target="_blank" [attr.href]="roadBlock.link"><img [src]="roadBlock.imagePath"></a>
          <button mat-button (click)="close()" class="theme-button">Close (X)</button>
      </div>    
  </div>
</div>
<div class="app" *ngIf="viewed">
  <app-header></app-header>
  <router-outlet></router-outlet> 
  <div class="end-image"></div>
  <app-footer></app-footer>
</div>

